<!-- Actions Bar Component -->
<div class="actions-bar" role="toolbar" aria-label="Job actions">
  <!-- Watch Options -->
  <app-watcher 
    [moduleID]="moduleID" 
    [referenceID]="referenceID" 
    [watchUserDetail]="watchUserDetail"
    (watchOptionSelected)="onWatchOptionSelected.emit($event)"
    class="watcher-in-actions-bar"
  >
  </app-watcher>
  
  <!-- Divider -->
  <div class="actions-divider"></div>
  
  <!-- Print Button -->
 <!-- <button 
    mat-button 
    class="action-button ghost-button"
    (click)="handlePrint()"
    matTooltip="Print job details"
    matTooltipPosition="above"
    aria-label="Print job details">
    <mat-icon class="action-icon">print</mat-icon>
  </button> -->

  <!-- Export Button -->
   <!--
  <button 
    mat-button 
    class="action-button ghost-button"
    (click)="handleExport()"
    matTooltip="Export to PDF"
    matTooltipPosition="above"
    aria-label="Export job details to PDF">
    <mat-icon class="action-icon">file_download</mat-icon>
  </button>
  -->

  <!-- Share Button -->
  <button
    mat-button
    class="action-button ghost-button"
    (click)="handleShare()"
    matTooltip="Share job details,feature coming soon"
    matTooltipPosition="above"
    matTooltipClass="actions-bar-tooltip"
    aria-label="Share job details">
    <mat-icon class="action-icon">share</mat-icon>
  </button>

  <!-- Email launcher: New Email + this module's templates (searchable) -->
  <app-email-launcher
    [moduleId]="moduleID"
    [moduleName]="moduleName"
    [recordId]="referenceID"
    [recordName]="recordName"
    [defaultSubject]="emailSubject"
    tooltip="Email">
  </app-email-launcher>
</div>